import * as React from 'react';
import { NavLink } from 'react-router-dom';
import { IGenre, IMedia, IPagination, EFilter, EVideoclub, IVideoclubStat, ICity } from '../interfaces';
import Axios, { AxiosResponse } from 'axios';
import config from '../config';
import Film from '../components/videoclub/Film';
import Pagination from '../components/common/Pagination';
import FilterBox from '../components/videoclub/FilterBox';
import Serial from '../components/videoclub/Serial';
import Trailers from '../components/home/Trailers';
import { withTranslation } from 'react-i18next';
import i18n from '../config/i18next';
import Banner from '../components/parts/Banner';
import FilmsPagination from '../components/common/FilmsPagination';
import SerialsPagination from '../components/common/SerialsPagination';
import { Helmet } from 'react-helmet';

interface IState {
    genres: IGenre[],
    cities: ICity[],
    films: IMedia[],
    years: number[],
    isLoading: boolean,
    isStatLoading: boolean,
    currentPage: number,
    year: number,
    genre_id: number,
    city_id: number,
    totalPages: number,
    pages: IPagination,
    filter: EFilter,
    stat: IVideoclubStat[]
}

interface IProps {
    type: EVideoclub,
    match: any,
    t: any,
    history: any
}

const CancelToken = Axios.CancelToken;
let cancel: any;

declare global {
    interface Window {
        head_tag_slot_vars: any
    }

}

class Videoclub extends React.Component<IProps, IState> {
    private _isUnmounted: boolean = false;

    constructor(props: any) {
        super(props);

        this.onPageChange = this.onPageChange.bind(this);
        this.onFilterChange = this.onFilterChange.bind(this);
        this.onGenreChange = this.onGenreChange.bind(this);
        this.onYearChange = this.onYearChange.bind(this);
        this.onCityChange = this.onCityChange.bind(this);
    }

    public state: IState = {
        genres: [],
        cities: [],
        films: [],
        years: [],
        isLoading: true,
        genre_id: this.props.match.params.genre_id,
        city_id: this.props.match.params.city_id,
        year: this.props.match.params.year,
        isStatLoading: true,
        currentPage: this.props.match.params.current_page ? Number.parseInt(this.props.match.params.current_page) : 1,
        totalPages: 1,
        pages: null,
        filter: EFilter.NEWEST,
        stat: []
    }

    onPageChange(page: number) {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth'
        });

        this.setState({
            currentPage: page,
            // isLoading: true,
            // films: []
        }, async () => {
            await this.loadFilms();

        });
    }

    async onFilterChange(filter: EFilter) {
        if (filter != this.state.filter) {
            this.setState({
                filter,
                isLoading: true,
                films: [],
                currentPage: 1
            }, async () => {
                await this.loadFilms();
            });
        }
    }

    async loadFilms() {

        cancel && cancel();

        try {

            let response = await Axios.get((this.state.currentPage == 1 ? `${config.site}/${i18n.language}/api/${this.props.type}/videoclub?order=${this.state.filter}` : `${config.site}/${i18n.language}/api/${this.props.type}/videoclub?order=${this.state.filter}&${this.state.pages ? this.state.pages.pageParam : "page-videoclub"}=${this.state.currentPage}`) + (this.state.genre_id ? `&genre_id=${this.state.genre_id}` : ``) + (this.state.city_id ? `&city_id=${this.state.city_id}` : ``) + (this.state.year ? `&year=${this.state.year}` : ``), {
                cancelToken: new CancelToken(function executor(c) {
                    cancel = c;
                })
            })

            if (!this._isUnmounted) {
                let totalPages = response.data.pages.pageCount;

                this.setState({
                    genres: response.data.genres,
                    films: response.data.media,
                    cities: response.data.cities,
                    years: response.data.years,
                    isLoading: false,
                    totalPages: totalPages,
                    currentPage: totalPages == 0 ? 0 : (totalPages > 0 && totalPages > this.state.currentPage ? this.state.currentPage : 1),
                    pages: response.data.pages
                });
            }
        } catch (err) {
            console.log(err);
        }

    }

    componentWillReceiveProps(props: any) {
        if (props.match.params.current_page > this.state.totalPages) {
            this.props.history.push("/not-found");
            return;
        }

        this.setState({
            currentPage: props.match.params.current_page ? Number.parseInt(props.match.params.current_page) : 1,
        }, this.componentDidMount);
    }



    onGenreChange(genre_id: number) {
        if (!this.state.year && !this.state.city_id)
            this.props.history.push("/" + (this.props.type == EVideoclub.FILMS ? "films" : "serials") + "/genre/" + genre_id);

        this.setState({
            genre_id,
            films: [],
            isLoading: true,
        }, async () => {
            await this.loadFilms();
        });
    }

    onCityChange(city_id: number) {
        if (!this.state.year && !this.state.genre_id)
            this.props.history.push("/" + (this.props.type == EVideoclub.FILMS ? "films" : "serials") + "/city/" + city_id);

        this.setState({
            city_id,
            films: [],
            isLoading: true,
        }, async () => {
            await this.loadFilms();
        });
    }

    onYearChange(year: number) {
        if (!this.state.genre_id && !this.state.city_id)
            this.props.history.push("/" + (this.props.type == EVideoclub.FILMS ? "films" : "serials") + "/year/" + year);

        this.setState({
            year,
            films: [],
            isLoading: true,
        }, async () => {
            await this.loadFilms();
        });
    }

    componentWillUnmount() {
        this._isUnmounted = true;
    }

    componentDidMount() {
        this.loadFilms();

        Axios.get(`${config.site}/${i18n.language}/api/stat/videoclub-genre`).then((response: AxiosResponse) => {
            if (!this._isUnmounted) {
                this.setState({
                    stat: response.data,
                    isStatLoading: false
                });
            }
        });
    }

    render() {
        const { t } = this.props;

        let currentGenre = this.state.genres.find((genre: IGenre) => genre.genre_id == this.state.genre_id);
        let currentCity = this.state.cities.find((city: ICity) => city.city_id == this.state.city_id);

        return (
            <div className="i-body">
                <Helmet>
                    {this.props.type == EVideoclub.FILMS && (<title>{t("Фильмы") + " | " + window.location.host.toUpperCase() + " - Медиа портал в TAS-IX"}</title>)}
                    {this.props.type == EVideoclub.SERIALS && (<title>{t("Сериалы") + " | " + window.location.host.toUpperCase() + " - Медиа портал в TAS-IX"}</title>)}
                    {this.props.type == EVideoclub.TRAILERS && (<title>{t("Трейлеры") + " | " + window.location.host.toUpperCase() + " - Медиа портал в TAS-IX"}</title>)}
                </Helmet>
                <div className="container v-index" style={{ position: "relative" }}>
                    <div className="wrapper">
                        <div className="wrap games">
                            <h4>
                                {this.props.type == EVideoclub.FILMS && t("Фильмы")}
                                {this.props.type == EVideoclub.SERIALS && t("Сериалы")}
                                {this.props.type == EVideoclub.TRAILERS && t("Трейлеры")}

                                <ul className="oth">
                                    {this.props.type != EVideoclub.FILMS && <li><NavLink to="/films">{t("Фильмы")}</NavLink></li>}
                                    {this.props.type != EVideoclub.SERIALS && <li><NavLink to="/serials">{t("Сериалы")}</NavLink></li>}
                                    {this.props.type != EVideoclub.TRAILERS && <li><NavLink to="/trailers">{t("Трейлеры")}</NavLink></li>}
                                </ul>
                            </h4>
                        </div>
                        <FilterBox currentGenre={currentGenre} currentCity={currentCity} year={this.state.year} onYearChange={this.onYearChange} onGenreChange={this.onGenreChange} onCityChange={this.onCityChange} onChange={this.onFilterChange} filter={this.state.filter} genres={this.state.genres} years={this.state.years} cities={this.state.cities} />
                        <div className="films">
                            {this.state.isLoading && (<div className="carousel-placeholder"></div>)}
                            {!this.state.isLoading && this.state.films.length == 0 && (<h4 className="mt-10 text-center">{t("Ничего не найдено")}</h4>)}
                            <div className="flex">
                                {this.state.films.map((film: IMedia, index: number) => {
                                    return this.props.type == EVideoclub.SERIALS ? (<Serial key={index} film={film} />) : (<Film key={index} film={film} />);
                                })}
                            </div>
                        </div>
                        {!this.state.isLoading && this.state.films.length > 0 && (this.props.match.params.genre_id || this.props.match.params.city_id || this.props.match.params.year ? <Pagination currentPage={this.state.currentPage} totalPages={this.state.totalPages} onChange={this.onPageChange} /> : (this.props.type == EVideoclub.SERIALS ? <SerialsPagination currentPage={this.state.currentPage} totalPages={this.state.totalPages} onChange={this.onPageChange} /> : <FilmsPagination currentPage={this.state.currentPage} totalPages={this.state.totalPages} onChange={this.onPageChange} />))}
                    </div>

                    <Banner className="banner235" place={5} />

                    {this.state.isStatLoading ? (<div className="carousel-placeholder"></div>) : (
                        <div className="statis">
                            <ul>
                                {this.state.stat.map((stat: IVideoclubStat, index: number) => {
                                    return (
                                        <li key={index}>
                                            <NavLink to={"/films/genre/" + stat.genre.genre_id} className="info">
                                                {stat.genre.name} <br /> {stat.count}
                                            </NavLink>
                                            <img className="w-100" src={stat.fullpath} alt={stat.genre.name} />
                                        </li>
                                    );
                                })}
                            </ul>
                            <div className="clearfix"></div>
                        </div>
                    )}
                    <Trailers showFilters={false} />
                </div>
            </div>
        );
    }
}

export default withTranslation()(Videoclub);